import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import moment from "moment";
import QRCode from "qrcode.react";
import { buildLinkedInUrl, buildShareWebUrl } from "./../../../helper/linkedinShare.js";

class CertificateViewer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { logoBase64: null };
    this.certificateRef = React.createRef();
    this.qrRef = React.createRef();
  }

  componentDidMount() {
    // Pre-carrega a logo via proxy backend (CORS aberto, evita tainted canvas no PDF)
    this.preloadLogo();
  }

  preloadLogo() {
    try {
      var backend = sessionStorage.getItem('backend');
      if (!backend) return;

      var img = new Image();
      img.crossOrigin = 'Anonymous';
      var self = this;
      img.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth || 200;
          canvas.height = img.naturalHeight || 100;
          canvas.getContext('2d').drawImage(img, 0, 0);
          var dataUrl = canvas.toDataURL('image/png');
          if (dataUrl && dataUrl.length > 200) {
            self.setState({ logoBase64: dataUrl, logoW: img.naturalWidth, logoH: img.naturalHeight });
          }
        } catch (e) { /* CORS bloqueou — segue com texto */ }
      };
      img.onerror = function () { /* logo nao disponivel */ };
      img.src = backend + '/badge/logo.png';
    } catch (e) {}
  }

  // Obtem a URL publica de verificacao do certificado
  getVerifyUrl() {
    try {
      var origin = window.location.origin;
      return origin + '/certificate/verify/' + this.props.certificate.certificateCode;
    } catch (e) {
      return 'Codigo: ' + this.props.certificate.certificateCode;
    }
  }

  // Pega o QR Code renderizado como base64 pra usar no PDF
  getQRCodeDataURL() {
    try {
      var canvas = document.getElementById('cert-qr-' + this.props.certificate.certificateCode);
      if (canvas && canvas.toDataURL) {
        return canvas.toDataURL('image/png');
      }
    } catch (e) {
      console.error('Erro ao obter QR code:', e);
    }
    return null;
  }

  // Monta a URL da logo da escola (mesma que o header HTML usa)
  getLogoUrl() {
    try {
      var backend = sessionStorage.getItem('backend');
      if (backend && window.app && window.app.state && window.app.state.confs) {
        var logo = window.app.state.confs.internal_logo || window.app.state.confs.logo;
        if (logo) return backend + logo;
      }
    } catch (e) {}
    return null;
  }

  // Carrega a logo como data URL (base64) pra embutir no PDF.
  // Usa crossOrigin pra evitar tainted canvas; se falhar (CORS/erro), resolve null e o PDF cai no texto.
  loadImageAsDataURL(url) {
    return new Promise((resolve) => {
      try {
        if (!url) { resolve(null); return; }
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          try {
            var canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            canvas.getContext('2d').drawImage(img, 0, 0);
            resolve({ dataUrl: canvas.toDataURL('image/png'), width: img.naturalWidth, height: img.naturalHeight });
          } catch (e) {
            resolve(null);
          }
        };
        img.onerror = function () { resolve(null); };
        img.src = url;
      } catch (e) {
        resolve(null);
      }
    });
  }

  getSkillColor(level) {
    var colors = {
      'Avançado': '#28a745',
      'Intermediário': '#ffc107',
      'Iniciante': '#17a2b8'
    };
    return colors[level] || '#6c757d';
  }

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : { r: 0, g: 0, b: 0 };
  }

  // Retorna o nome do sistema (SuperGeeks, CS Plus, etc.)
  getSystemName() {
    try {
      if (window.app && window.app.state && window.app.state.confs && window.app.state.confs.systemName) {
        return window.app.state.confs.systemName;
      }
    } catch (e) {}
    return 'SuperGeeks';
  }

  async downloadPDF() {
    try {
      var jsPDF = require('jspdf');
      var doc = new jsPDF.jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

      var cert = this.props.certificate;
      var userName = this.props.userName || cert.userName + ' ' + (cert.userLastName || '');
      var courseName = cert.courseName || cert.classroomName || 'Certificado de Conclusao';
      var classroomName = cert.classroomName || '';
      var systemName = this.getSystemName();

      // Tenta carregar a logo da escola pra embutir no PDF (cai no texto se nao conseguir)
      var logoData = await this.loadImageAsDataURL(this.getLogoUrl());

      // Background branco
      doc.setFillColor(255, 255, 255);
      doc.rect(0, 0, 297, 210, 'F');

      // Borda externa vermelha
      doc.setDrawColor(220, 53, 69);
      doc.setLineWidth(3);
      doc.rect(8, 8, 281, 194);

      // Borda interna dourada
      doc.setDrawColor(255, 215, 0);
      doc.setLineWidth(1);
      doc.rect(12, 12, 273, 186);

      // Decoracao de cantos
      doc.setDrawColor(255, 215, 0);
      doc.setLineWidth(0.5);
      doc.line(16, 20, 36, 20); doc.line(16, 20, 16, 40);
      doc.line(261, 20, 281, 20); doc.line(281, 20, 281, 40);
      doc.line(16, 170, 36, 170); doc.line(16, 170, 16, 190);
      doc.line(261, 170, 281, 170); doc.line(281, 170, 281, 190);

      // === LOGO DA ESCOLA (imagem; cai no texto se a logo nao carregar) ===
      // If loading the school logo now fails (e.g. CORS), use the one preloaded through the backend proxy.
      if (!(logoData && logoData.dataUrl) && this.state.logoBase64 && this.state.logoW && this.state.logoH) {
        logoData = { dataUrl: this.state.logoBase64, width: this.state.logoW, height: this.state.logoH };
      }
      if (logoData && logoData.dataUrl) {
        // Escala a logo respeitando a proporcao, com limites pra caber no cabecalho
        var maxLogoH = 16, maxLogoW = 70;
        var ratio = (logoData.width && logoData.height) ? (logoData.width / logoData.height) : 1;
        var logoH = maxLogoH;
        var logoW = logoH * ratio;
        if (logoW > maxLogoW) { logoW = maxLogoW; logoH = logoW / ratio; }
        doc.addImage(logoData.dataUrl, 'PNG', 148.5 - logoW / 2, 18, logoW, logoH);
      } else {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(20);
        doc.setTextColor(220, 53, 69);
        doc.text(systemName.toUpperCase(), 148.5, 32, { align: 'center' });
      }

      // Titulo CERTIFICADO DE CONCLUSAO
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(28);
      doc.setTextColor(220, 53, 69);
      doc.text('CERTIFICADO DE CONCLUSAO', 148.5, 48, { align: 'center' });

      // Linha decorativa dourada
      doc.setDrawColor(255, 215, 0);
      doc.setLineWidth(1);
      doc.line(74, 52, 223, 52);

      // === NOME DO CURSO ===
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(15);
      doc.setTextColor(60, 60, 60);
      doc.text(courseName, 148.5, 65, { align: 'center' });

      // === NOME DA TURMA ===
      var yPos = 72;
      if (classroomName) {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        doc.setTextColor(140, 140, 140);
        doc.text('Turma: ' + classroomName, 148.5, yPos, { align: 'center' });
        yPos += 8;
      }

      // Certificamos que
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(11);
      doc.setTextColor(120, 120, 120);
      doc.text('Certificamos que', 148.5, yPos + 4, { align: 'center' });

      // === NOME DO ALUNO ===
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(24);
      doc.setTextColor(40, 40, 40);
      doc.text(userName.trim(), 148.5, yPos + 18, { align: 'center' });

      // Linha sob o nome
      doc.setDrawColor(220, 53, 69);
      doc.setLineWidth(0.5);
      var nameWidth = doc.getTextWidth(userName.trim());
      var halfName = nameWidth / 2;
      doc.line(148.5 - halfName - 5, yPos + 22, 148.5 + halfName + 5, yPos + 22);

      // concluiu com sucesso...
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setTextColor(120, 120, 120);
      doc.text('concluiu com sucesso o curso acima mencionado com nivel', 148.5, yPos + 32, { align: 'center' });

      // === NIVEL ===
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      var skillColor = this.getSkillColor(cert.skillLevel);
      var rgb = this.hexToRgb(skillColor);
      doc.setTextColor(rgb.r, rgb.g, rgb.b);
      doc.text(cert.skillLevel || 'Iniciante', 148.5, yPos + 44, { align: 'center' });

      // === ESTATISTICAS ===
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.setTextColor(140, 140, 140);
      var stats = [];
      if (cert.totalHours > 0) stats.push('Carga horaria: ' + parseFloat(cert.totalHours).toFixed(0) + 'h');
      if (cert.averageScore > 0) stats.push('Media: ' + parseFloat(cert.averageScore).toFixed(1));
      if (stats.length > 0) {
        doc.text(stats.join('   |   '), 148.5, yPos + 52, { align: 'center' });
      }

      // === MEDALHA DOURADA ===
      doc.setFillColor(255, 215, 0);
      doc.circle(148.5, yPos + 62, 5, 'F');
      doc.setDrawColor(218, 165, 32);
      doc.setLineWidth(0.5);
      doc.circle(148.5, yPos + 62, 5, 'S');
      doc.setFillColor(255, 255, 255);
      doc.circle(148.5, yPos + 62, 2, 'F');
      doc.setFillColor(255, 215, 0);
      doc.circle(148.5, yPos + 62, 1, 'F');

      // === QR CODE (canto inferior direito) ===
      try {
        var qrDataUrl = this.getQRCodeDataURL();
        if (qrDataUrl) {
          // QR 22x22mm, canto inferior direito
          doc.addImage(qrDataUrl, 'PNG', 250, 160, 22, 22);
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(7);
          doc.setTextColor(140, 140, 140);
          doc.text('Verificar', 261, 186, { align: 'center' });
        }
      } catch (qrErr) {
        console.error('Erro ao adicionar QR code:', qrErr);
      }

      // === DATA E CODIGO ===
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.setTextColor(160, 160, 160);
      doc.text('Emitido em: ' + moment(cert.completionDate).format('DD/MM/YYYY'), 148.5, 176, { align: 'center' });

      doc.setFont('courier', 'bold');
      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.text('Codigo de verificacao: ' + cert.certificateCode, 148.5, 183, { align: 'center' });

      doc.save('certificado-' + cert.certificateCode + '.pdf');
    } catch (err) {
      console.error('Erro ao gerar PDF:', err);
      alert('Erro ao gerar PDF: ' + err.message);
    }
  }

  render() {

    var cert = this.props.certificate;
    var userName = this.props.userName || (cert.userName + ' ' + (cert.userLastName || ''));
    var courseName = cert.courseName || cert.classroomName || 'Certificado de Conclusao';
    var classroomName = cert.classroomName || '';
    var courseIcon = cert.courseIcon || cert.courseCover || null;

    // Logo da escola: pega do backend dinamicamente (mesmo que a sidebar usa)
    var schoolLogoUrl = null;
    var systemName = this.getSystemName();
    try {
      var backend = sessionStorage.getItem('backend');
      if (backend && window.app && window.app.state && window.app.state.confs) {
        schoolLogoUrl = backend + (window.app.state.confs.internal_logo || window.app.state.confs.logo);
      }
    } catch (e) {}

    return (
      <Modal isOpen={true} toggle={() => this.props.onClose()} size="lg" centered>
        <ModalBody className="p-0">
          <div
            ref={this.certificateRef}
            style={{
              background: 'linear-gradient(135deg, #fff 0%, #fefefe 50%, #f8f9fa 100%)',
              border: '3px solid #dc3545',
              borderRadius: '8px',
              padding: '0',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            {/* Borda interna dourada */}
            <div style={{
              position: 'absolute',
              top: '6px', left: '6px', right: '6px', bottom: '6px',
              border: '1px solid #FFD700',
              borderRadius: '4px',
              pointerEvents: 'none'
            }} />

            {/* Header vermelho com logo */}
            <div style={{
              background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
              padding: '16px 40px 12px',
              textAlign: 'center',
              position: 'relative'
            }}>
              {/* Logo da escola */}
              {schoolLogoUrl ? (
                <img
                  src={schoolLogoUrl}
                  alt={systemName}
                  style={{ maxHeight: '45px', maxWidth: '180px', marginBottom: '8px', objectFit: 'contain' }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    // Mostra o nome como texto quando a imagem falha
                    var fallback = e.target.nextSibling;
                    if (fallback) fallback.style.display = 'block';
                  }}
                />
              ) : null}
              <div style={{
                display: schoolLogoUrl ? 'none' : 'block',
                color: '#fff',
                fontSize: '1.1rem',
                fontWeight: 700,
                letterSpacing: '4px',
                marginBottom: '6px'
              }}>
                {systemName.toUpperCase()}
              </div>
              <h2 style={{
                color: '#fff',
                fontWeight: 700,
                fontSize: '1.5rem',
                margin: 0,
                letterSpacing: '3px',
                textShadow: '0 1px 3px rgba(0,0,0,0.2)'
              }}>
                CERTIFICADO DE CONCLUSAO
              </h2>
              <div style={{
                width: '80px',
                height: '3px',
                backgroundColor: '#FFD700',
                margin: '8px auto 0'
              }} />
            </div>

            {/* Corpo do certificado */}
            <div className="text-center" style={{ padding: '20px 40px 16px', position: 'relative', zIndex: 1 }}>

              {/* Icone e nome do curso */}
              <div className="mb-2">
                {courseIcon && (
                  <img
                    src={courseIcon}
                    alt="Curso"
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '8px',
                      objectFit: 'cover',
                      marginBottom: '8px',
                      border: '2px solid #eee',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                )}
                <h3 style={{
                  color: '#333',
                  fontWeight: 700,
                  fontSize: '1.2rem',
                  marginBottom: '2px'
                }}>
                  {courseName}
                </h3>
                {classroomName && (
                  <p className="text-muted mb-0" style={{ fontSize: '0.8rem' }}>
                    <i className="fas fa-chalkboard mr-1" />
                    Turma: {classroomName}
                  </p>
                )}
              </div>

              <p className="text-muted mb-1" style={{ fontSize: '0.85rem' }}>Certificamos que</p>

              {/* Nome do aluno */}
              <h2 style={{
                fontWeight: 700,
                fontSize: '1.7rem',
                color: '#222',
                borderBottom: '2px solid #dc3545',
                display: 'inline-block',
                paddingBottom: '4px',
                marginBottom: '10px'
              }}>
                {userName.trim()}
              </h2>

              <p className="text-muted mb-1" style={{ fontSize: '0.8rem' }}>
                concluiu com sucesso o curso acima mencionado com nivel
              </p>

              {/* Nivel */}
              <div className="mb-2">
                <span style={{
                  display: 'inline-block',
                  backgroundColor: this.getSkillColor(cert.skillLevel),
                  color: '#fff',
                  padding: '5px 22px',
                  borderRadius: '20px',
                  fontSize: '1rem',
                  fontWeight: 700,
                  boxShadow: '0 2px 8px ' + this.getSkillColor(cert.skillLevel) + '40'
                }}>
                  {cert.skillLevel || 'Iniciante'}
                </span>
              </div>

              {/* Estatisticas */}
              <div className="d-flex justify-content-center mb-2">
                {cert.totalHours > 0 && (
                  <span className="mx-2" style={{
                    backgroundColor: '#e3f2fd',
                    padding: '3px 12px',
                    borderRadius: '15px',
                    fontSize: '0.8rem',
                    color: '#1565c0'
                  }}>
                    <i className="fas fa-clock mr-1" />
                    {parseFloat(cert.totalHours).toFixed(0)}h
                  </span>
                )}
                {cert.averageScore > 0 && (
                  <span className="mx-2" style={{
                    backgroundColor: '#fff3e0',
                    padding: '3px 12px',
                    borderRadius: '15px',
                    fontSize: '0.8rem',
                    color: '#e65100'
                  }}>
                    <i className="fas fa-star mr-1" />
                    Media: {parseFloat(cert.averageScore).toFixed(1)}
                  </span>
                )}
              </div>

              {/* Medalha dourada */}
              <div className="mb-2">
                <span style={{
                  display: 'inline-block',
                  width: '40px',
                  height: '40px',
                  background: 'linear-gradient(135deg, #FFD700, #FFA000)',
                  borderRadius: '50%',
                  lineHeight: '40px',
                  color: '#fff',
                  fontSize: '1.2rem',
                  boxShadow: '0 3px 10px rgba(255,215,0,0.4)',
                  border: '2px solid #DAA520'
                }}>
                  <i className="fas fa-award" />
                </span>
              </div>

              {/* Data, codigo e QR */}
              <div style={{ borderTop: '1px solid #eee', paddingTop: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>
                  <div>
                    <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                      <i className="fas fa-calendar-alt mr-1" />
                      Emitido em: {moment(cert.completionDate).format('DD/MM/YYYY')}
                    </p>
                    <p className="mb-0" style={{ fontSize: '0.8rem', color: '#555' }}>
                      <i className="fas fa-shield-alt mr-1" />
                      <strong style={{ letterSpacing: '1px', fontFamily: 'monospace' }}>{cert.certificateCode}</strong>
                    </p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <QRCode
                      id={'cert-qr-' + cert.certificateCode}
                      value={this.getVerifyUrl()}
                      size={64}
                      level="M"
                      includeMargin={false}
                      renderAs="canvas"
                    />
                    <small className="d-block text-muted" style={{ fontSize: '0.65rem' }}>Verificar</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Acoes */}
          <div className="d-flex justify-content-center py-3 bg-light flex-wrap" style={{ borderTop: '1px solid #eee', gap: '8px' }}>
            <Button color="danger" size="sm" onClick={() => this.downloadPDF()}>
              <i className="fas fa-download mr-2" />
              Baixar PDF
            </Button>
            <Button
              size="sm"
              style={{ backgroundColor: '#0A66C2', color: '#fff', border: 'none' }}
              onClick={() => {
                var url = buildLinkedInUrl(cert);
                if (url) window.open(url, '_blank', 'width=700,height=600');
              }}
            >
              <i className="fab fa-linkedin mr-2" />
              Adicionar ao LinkedIn
            </Button>
            <Button
              size="sm"
              outline
              color="info"
              onClick={() => {
                var url = buildShareWebUrl(this.getVerifyUrl());
                if (url) window.open(url, '_blank', 'width=600,height=500');
              }}
            >
              <i className="fas fa-share-alt mr-2" />
              Compartilhar
            </Button>
            <Button color="secondary" size="sm" onClick={() => this.props.onClose()}>
              Fechar
            </Button>
          </div>
        </ModalBody>
      </Modal>
    );

  }

}

export default CertificateViewer;
